module.exports = __webpack_public_path__ + "img/momo_home_bg_5.f7f0fa85.png";